<div class="ml-3">
  <div class="text-lg">
    Notification Schedules
</div>

  <div class="flex justify-content-between mt-6 pr-4">
      <div class="flex flex-row gap-3">
        <creditor-autocomplete
        (onSelect)="onSelectCreditor($event)"
        ></creditor-autocomplete>

        <p-button (click)="search()" styleClass="text-xs" label="Get" icon="pi pi-search text-xs" [outlined]="true" severity="secondary"></p-button>   
      </div>

      <p-button label="Add New" icon="pi pi-plus" (click)="onOpenSideBar()" [outlined]="true"></p-button>
      
  </div>
  <div class="mt-4">
      <p-table [value]="notificationSchedules" 
               [paginator]="true"
               [rows]="5"
               [tableStyle]="{ 'min-width': '50rem' }"
               [rowsPerPageOptions]="[5, 10, 20]">

          <ng-template pTemplate="header">
              <tr class="text-xs">
                  <th>Notification Schedule Id</th>
                  <th>Day</th>
                  <th>Preferred Time</th>
                  <th>Start Time</th>  
                  <th>End Time</th>   
                  <th>Is Active</th>              
                  <th>Created On UTC</th>   
                  <th>Created By</th> 
                  <th>Updated On UTC</th>        
                  <th>Updated By</th>                 
                  <th>Deleted On UTC</th>            
                  <th>Deleted By</th>   
                  <th>Action</th>            
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-schedule>
              <tr class="text-xs">
                  <td>{{ schedule.notificationScheduleId }}</td>
                  <td>{{ schedule.day }}</td>
                  <td>
                    <span *ngIf="formatTime(schedule?.preferredTimeUtc) as formattedTime; else noData">
                      {{ formattedTime | date : 'h:mma' }}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="formatTime(schedule?.startTimeUtc) as formattedTime; else noData">
                      {{ formattedTime | date : 'h:mma' }}
                    </span>
                  </td>  
                  <td>
                    <span *ngIf="formatTime(schedule?.endTimeUtc) as formattedTime; else noData">
                      {{ formattedTime | date : 'h:mma' }}
                    </span>
                  </td>  
                  <td>{{ schedule.isActive }}</td>      
                  <td>
                    <span *ngIf="schedule?.createdOnUtc && schedule.createdOnUtc !== '00:00:00'; else noData">
                      {{ schedule.createdOnUtc | date : 'MMMM d, y' }}
                    </span>
                  </td>   
                  <td>{{ schedule.createdBy }}</td>  
                  <td>
                    <span *ngIf="schedule?.updatedOnUtc && schedule.updatedOnUtc !== '00:00:00'; else noData">
                      {{ schedule.updatedOnUtc | date : 'MMMM d, y' }}
                    </span>
                  </td>  
                  <td>{{ schedule.updatedBy || '-'  }}</td> 
                  <td>
                    <span *ngIf="schedule?.deletedOnUtc && schedule.deletedOnUtc !== '00:00:00'; else noData">
                      {{ schedule.deletedOnUtc | date : 'MMMM d, y'  }}
                    </span>                    
                  </td>
                  <td>{{ schedule.deletedBy || '-' }}</td> 
                  <td>
                    <div class="flex align-items-center">
                        <i class="pi pi-pencil text-xs cursor-pointer"  pTooltip="Edit" tooltipPosition="left" (click)="onOpenSideBar(schedule)"></i>
                    </div>
                </td>   
              </tr>
          </ng-template>
      </p-table>
  </div>

</div>

<ng-template #noData>–</ng-template>

<p-sidebar [(visible)]="isSideBarVisible" styleClass="w-7" position="right">
  <div class="text-xl">{{editedId? 'Edit ' : 'Add New '}} Notification Schedule</div>

  <div class="bg-white shadow-2 border-round-lg mt-6 p-0 flex">
   <div class="w-11rem border-round-left-lg bg-primary p-4 flex align-items-center justify-content-center">
      <div class="flex justify-content-center align-items-center px-4 py-2">
          <p-dropdown 
            styleClass="bg-primary text-white p-dropdown-label-white"
            [options]="dayOptions" 
            [(ngModel)]="selectedDay" 
            optionLabel="name" 
            placeholder="Select Day">
            <ng-template pTemplate="selectedItem">
              <div class="text-white" *ngIf="selectedDay">
                 {{selectedDay.name}}
              </div>
          </ng-template>
          </p-dropdown>

      </div>      
   </div>

  <div class="flex align-items-center justify-content-center  flex-1">
    <div class="p-4 flex justify-content-center align-items-start w-full">
      <div class="flex flex-column align-items-end w-6">
        <div class="flex align-items-center">
          <div>
            Preferred Time
          </div>
          <p-calendar 
            class="ml-2 w-11rem children-bg-primary"
            inputId="preferred-time"  
            [timeOnly]="true" 
            hourFormat="12"
            [showIcon]="true"
            [(ngModel)]="preferredTime" 
            />
        </div>
  
        <div class="flex align-items-center mt-3">
          <div>
            End Time
          </div>
          <p-calendar 
            class="ml-2 w-11rem children-bg-primary"
            inputId="end-time"  
            [timeOnly]="true"
            hourFormat="12"
            [showIcon]="true" 
            [(ngModel)]="endTime"            
            />
        </div>
      </div>
  
      <div class="flex flex-column pl-5 w-6">
        <div class="flex align-items-center">
          <div>
            Start Time
          </div>
          <p-calendar 
            class="ml-2 w-11rem children-bg-primary"
            inputId="start-time"  
            [timeOnly]="true"
            hourFormat="12"
            [showIcon]="true" 
            [(ngModel)]="startTime"  
            />
        </div>

        <div class="flex align-items-center ml-2 mt-5">
          <div>
            Is Active&nbsp;
          </div>
          <p-checkbox 
            [(ngModel)]="isActive"
            class="ml-2"
            [binary]="true" 
            inputId="binary" />
        </div>
        
      </div>
    </div>
  </div>
   
  </div>

  <div class="flex justify-content-end mt-6">
    <p-button (click)="onSave()" label="Save" icon="pi pi-send" [outlined]="true"></p-button>
  </div>
</p-sidebar>